import { useState } from 'react'
import { useAuthStore } from '@/store/authStore'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Badge } from '@/components/ui/badge'
import { AlertCircle } from 'lucide-react'
import { DocumentUpload } from './DocumentUpload'
import { AnnouncementsManager } from './AnnouncementsManager'
import { EscalationsView } from './EscalationsView'
import { AdminStats } from './AdminStats'

export function Admin() {
  const { partner } = useAuthStore()
  
  // Only admins should access this page
  if (!partner?.isAdmin) {
    return (
      <div className="flex h-[50vh] flex-col items-center justify-center">
        <AlertCircle className="h-12 w-12 text-muted-foreground" />
        <h2 className="mt-4 text-xl font-semibold">Access Denied</h2>
        <p className="mt-2 text-muted-foreground">
          This section is restricted to administrators.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold">Admin Panel</h1>
        <Badge className="bg-cloudflare-orange">Admin</Badge>
      </div>

      {/* Tabs */}
      <Tabs defaultValue="stats">
        <TabsList className="flex flex-wrap">
          <TabsTrigger value="stats">Dashboard</TabsTrigger>
          <TabsTrigger value="documents">Documents</TabsTrigger>
          <TabsTrigger value="announcements">Announcements</TabsTrigger>
          <TabsTrigger value="escalations">Escalations</TabsTrigger>
        </TabsList>

        <TabsContent value="stats">
          <AdminStats />
        </TabsContent>

        <TabsContent value="documents">
          <DocumentUpload />
        </TabsContent>

        <TabsContent value="announcements">
          <AnnouncementsManager />
        </TabsContent>

        <TabsContent value="escalations">
          <EscalationsView />
        </TabsContent>
      </Tabs>
    </div>
  )
}
